import { CheckCircle2, XCircle } from "lucide-react";

interface PlayerScorecardProps {
  player: any;
}

export function PlayerScorecard({ player }: PlayerScorecardProps) {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6 transition-colors duration-200">
      <div className="flex items-center mb-6">
        {player.profilePicture && (
          <img
            src={`/api/static/images/${player.profilePicture}`}
            alt={`${player.firstName} ${player.lastName}`}
            className="w-16 h-16 rounded-full mr-4"
          />
        )}
        <div>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
            {player.firstName} {player.lastName}
          </h2>
          <div className="flex items-center mt-1 space-x-4">
            <span className="text-gray-600 dark:text-gray-400">
              Handicap: {player.playerHandicap}
            </span>
            <span className="text-gray-600 dark:text-gray-400">
              Total Gross: {player.totalGross}
            </span>
            <span className="text-gray-600 dark:text-gray-400">
              Stableford: {player.totalStableford}
            </span>
          </div>
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700">
          <thead className="bg-gray-50 dark:bg-gray-900">
            <tr className="text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
              <th className="px-4 py-3 hidden md:table-cell">Hole</th>
              <th className="px-4 py-3">Score</th>
              <th className="px-4 py-3">Stableford</th>
            </tr>
          </thead>
          <tbody className="bg-white dark:bg-gray-800 divide-y divide-gray-200 dark:divide-gray-700">
            {player?.playerScores?.map((score: any) => (
              <tr
                key={score.holeNumber}
                className="hover:bg-gray-50 dark:hover:bg-gray-700 text-sm transition-colors duration-200"
              >
                <td className="px-4 py-3 whitespace-nowrap text-gray-900 dark:text-white hidden md:table-cell">
                  {score.holeNumber}
                </td>
                <td className="px-4 py-3 whitespace-nowrap flex items-center">
                  <span className="md:hidden mr-2">H{score.holeNumber}:</span>
                  <span className=" text-gray-900 dark:text-white ">{score.score}</span>
                  {score.isValid ? (
                    <CheckCircle2 className="w-4 h-4 text-green-500 ml-2" />
                  ) : (
                    <XCircle className="w-4 h-4 text-red-500 ml-2" />
                  )}
                </td>
                <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-900 dark:text-white">
                  {score.stablefordScore}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-gray-50 dark:bg-gray-900 p-4 rounded-lg transition-colors duration-200">
          <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 uppercase">
            Handicap Adjustment
          </h3>
          <p className="mt-1 text-2xl font-semibold text-gray-900 dark:text-white">
            {player.handicapAdjustment}
          </p>
        </div>
        <div className="bg-gray-50 dark:bg-gray-900 p-4 rounded-lg transition-colors duration-200">
          <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 uppercase">
            Revised Course Handicap
          </h3>
          <p className="mt-1 text-2xl font-semibold text-gray-900 dark:text-white">
            {player.revisedCourseHandicap}
          </p>
        </div>
        <div className="bg-gray-50 dark:bg-gray-900 p-4 rounded-lg transition-colors duration-200">
          <h3 className="text-sm font-medium text-gray-500 dark:text-gray-400 uppercase">
            Ranking Score
          </h3>
          <p className="mt-1 text-2xl font-semibold text-gray-900 dark:text-white">
            {player.rankingScore && player.rankingScore.toFixed(2)}
          </p>
        </div>
      </div>
    </div>
  );
}
